import { ReactNode } from "react";
import { getStatusStyles } from "../../../utils/helpers/dentalHelper";
import GlobalStyle from "../../../styles/GlobalStyle";
import {
  scaleVertical,
  scaleHorizontal,
  FontSizes,
} from "../../../styles/responsive";
import { V2ReportStyle } from "../../../styles/V2ReportStyle";
import StatusLabel from "../../UI/StatusLabel";

const NewHeightWeightCard = ({
  lable,
  icon,
  title,
  hwData,
  description,
}: {
  lable: any;
  icon: ReactNode;
  title: string;
  description?: ReactNode;
  hwData: string | number;
}) => {
  const { backgroundColor, color } = getStatusStyles(lable);

  return (
    <div style={{ ...V2ReportStyle.card, gap: scaleVertical(12) }}>
      <div
        style={{
          ...V2ReportStyle.flexRowCenter,
          justifyContent: "space-between",
        }}
      >
        <div
          style={{ ...V2ReportStyle.flexRowCenter, gap: scaleHorizontal(2) }}
        >
          {icon}
          <span style={{ ...GlobalStyle.blackBoldText, fontSize: "2.2rem" }}>
            {title}
          </span>
        </div>
        <StatusLabel lable={lable} />
      </div>

      <div style={{ ...V2ReportStyle.flexRowCenter, gap: scaleHorizontal(12) }}>
        <div
          style={{
            ...V2ReportStyle.flexColumnCenter,
            gap: scaleVertical(5),
          }}
        >
          <div
            style={{
              ...V2ReportStyle.measurebox,
              borderColor: color,
              backgroundColor,
            }}
          >
            <span
              style={{
                ...GlobalStyle.blackBoldText,
                fontSize: "2.2rem",
                color,
              }}
            >
              {hwData}
            </span>
          </div>
          <p
            style={{
              ...GlobalStyle.blackRegularText,
              fontSize: "2rem",
              margin: 0,
            }}
          >
            {description}
          </p>
        </div>
      </div>
    </div>
  );
};

export default NewHeightWeightCard;
